import React from 'react';
import AddCouponForm from 'src/components/couponManagement/addCoupon/AddCouponForm';

const AddCoupon = () => (
  <div><AddCouponForm /></div>
);

export default AddCoupon;
